export const LOCAL_STORAGE_USER_LOGGED_IN_KEY = 'isLoggedIn';
export const LOCAL_STORAGE_USER_DATA_KEY = 'userData';

export const XSRF_TOKEN_KEY = 'XSRF-TOKEN'

export const HTTP_UNAUTHORIZED = 401;
